function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Ebene_1"
}, /*#__PURE__*/React.createElement("title", null, "VF_"), /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M227.1 120.4l-.1 51.1L65.6 9.9l-20 20L207 191.4l-51 .1v28.2l99.3-.1v-99.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.3 255.1V0H0v283.5h283.5v-28.4z"
})))));